<template>
  <div id="page">
    <section
        class="category_top_banner cover"
        v-lazy:background-image="
				pageData.acf.titlebar.bg && $mq !== 'mobile'
					? pageData.acf.titlebar.bg
					:  pageData.acf.titlebar.bg_mobile
			"
    >
      <div class="container" :class="{ 'white-text': pageData.acf.titlebar.white_text }">
        <h1 class="title">{{ pageData.acf.titlebar.title ? pageData.acf.titlebar.title : pageData.title }}</h1>
        <div class="text">{{ pageData.acf.titlebar.subtitle ? pageData.acf.titlebar.subtitle : "" }}</div>
      </div>
      <div class="bn_corner"></div>
    </section>
    <div class="container">
      <div class="main_white main page col-lg-12">
        <div class="col-lg-7">
          <h2>{{ cashback.options.subtitle }}</h2>
          <br />
          <div class="cashback-instructions">
            <h3>איך צוברים נקודות?</h3>
            <div class="steps">
              <div class="step">
                <CashbackStep1 />
                <div>מזמינים בכרמלה</div>
              </div>
              <ArrowLeft class="arrow-left" />
              <div class="step">
                <CashbackStep2 />
                <div>צוברים 3% מסך ההזמנה</div>
              </div>
              <ArrowLeft class="arrow-left" />
              <div class="step">
                <CashbackStep3 />
                <div>מממשים נקודות</div>
                <span>* החל מיתרה של {{ cashback.options.minimum_points }} נקודות צבורות</span>
              </div>
            </div>
            <div v-html="pageData.post_content"></div>
            <div class="cashback-faq" v-if="cashback.options.faq">
              <h2>יש לכם שאלה? לנו יש את התשובות</h2>
              <div
                  class="career_row toggleContainer"
                  v-for="(faq, index) in cashback.options.faq"
                  :key="index"
              >
                <div class="career_top ease">
                  <a href="javascript:void(0);" onclick="toggle(this)">
                    {{ faq.title }}
                    <span class="show_icon"></span>
                  </a>
                </div>
                <div class="career_open toggleInner" v-html="faq.content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Cashback from "@/assets/img/cashback-big.svg";
import CashbackStep1 from "@/assets/img/cashback-step1.svg";
import CashbackStep2 from "@/assets/img/cashback-step2.svg";
import CashbackStep3 from "@/assets/img/cashback-step3.svg";
import ArrowLeft from "@/assets/img/arrow-left.svg";

export default {
  data() {
    return {
      title: "",
      content: "",
      page: "",
      cashback: this.$store.state.cashback,
    };
  },
  computed: {
    ...mapGetters({ pointsWorth: "getCashbackPointsWorth" }),
    pageData() {
      if (typeof wpData.pageData != "object") {
        return JSON.parse(wpData.pageData);
      }
      return wpData.pageData;
    },
  },
  beforeCreate() {},
  created() {
    this.$modal.hide("login-modal");
    console.log("this.pageData", this.pageData);
  },
  components: {
    Cashback,
    CashbackStep1,
    CashbackStep2,
    CashbackStep3,
    ArrowLeft,
  },
};
</script>
<style lang="sass" scoped>
#page
  .category_top_banner
    padding-top: 0
    height: 300px

    .container
      height: calc(100% - 30px)
      display: flex
      flex-direction: column
      justify-content: center

    h1
      margin: 0
      font-size: 35px
      font-weight: bold
      font-family: simpler, arial, sans-serif

    .text
      height: auto
      color: #1e824c
      font-family: 'raanancondensed', arial, sans-serif
      font-size: 50px
      line-height: normal

  .main
    border-radius: 0
    background: #fff url(../assets/img/cashback-bg.jpg) repeat-y top left/32% auto

  h1
    font-size: 28px

  h2
    color: #1e824c
    font-family: 'raanancondensed', arial, sans-serif
    font-size: 48px

  .subtitle
    font-size: 36px
    color: #000
    font-family: 'raanancondensed', arial, sans-serif
    line-height: 28px

  .cashback-inner
    margin: 2em 0
    padding: 2em 0
    border: 0 dashed #1e824c
    border-width: 1px 0
    display: flex
    align-items: center
    column-gap: 15px

    svg
      fill: #1e824c
      margin-top: -15px

    .cashback-content
      flex: 1

      .points b
        font-size: 170%
        line-height: 1
        font-weight: 900
        padding: 0 3px
        color: #000

      .no-points-wrap
        display: flex
        justify-content: space-around
        align-items: flex-end

        .no-points-title
          font-size: 35px
          line-height: 1
          font-weight: 900
          color: #000

    .button
      margin-right: auto
      background-color: #EC593A
      color: #fff
      border-radius: 100px
      border: 0
      font-size: 16px
      padding: 10px 15px
      transition: 300ms ease all
      white-space: nowrap

      &:hover
        background-color: #ff2e00

  .cashback-instructions
    color: #252526

    h3
      font-weight: bold
      margin-bottom: 10px

    .steps
      display: flex
      column-gap: 20px
      align-items: flex-end
      margin: 1em -1em 2em 0

      .step
        text-align: center
        position: relative
        min-width: 134px

        div
          font-family: 'raanancondensed', arial, sans-serif
          font-size: 25px
          color: #1E824C

        span
          font-size: 12px
          color: #000
          display: block
          margin: -7px 0 -12px

      .arrow-left
        margin: auto 0

  .cashback-faq
    margin-top: 4em

    h2
      color: #222
      border-bottom: 1px solid #c2bfb6
      font-size: 43px
      line-height: 2

@media (max-width: 480px)
  #page
    .category_top_banner
      height: 200px

      div.container
        height: 100%

        h1
          font-size: 28px

        .text
          font-size: 31px
          display: block
          max-width: 50%
          line-height: 0.9

      div.bn_corner
        display: none

    .main
      background: none

      .col-lg-7
        padding: 0

      h2
        font-size: 31px

      .cashback-instructions
        .steps
          transform: scale(0.75)
          margin: 0 -4em 0 0
          gap: 10px

          svg.arrow-left
            overflow: visible
</style>
